// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-desk-container .help-desk-style {
    /*z-index: 2147483000;*/
    position: fixed;
    bottom: 20px;
    width: 60px;
    height: 60px;
    box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;
    border-radius: 50%;
    background: rgb(36, 44, 52);
    animation: 250ms ease 0s 1 normal none running animation-bhegco;
    transition: opacity 0.3s ease 0s;
}

.webchat-draggable.help-desk-container .help-desk-style {
    bottom: 0px;
    width: 100px;
    height: 60px;
}

.help-desk-launcher-frame.show {
    opacity: 1!important;
    visibility: visible!important;
}

.help-desk-launcher-frame.hide {
  display: none;
}

.help-desk-container iframe {
    border-width: 0px;
    border-style: none;
    border-color: transparent;
    border-image: initial;
    border-radius: 0px;
}
`, "",{"version":3,"sources":["webpack://./dist/src/components/web-chat.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,qFAAqF;IACrF,kBAAkB;IAClB,2BAA2B;IAC3B,+DAA+D;IAC/D,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":[".help-desk-container .help-desk-style {\r\n    /*z-index: 2147483000;*/\r\n    position: fixed;\r\n    bottom: 20px;\r\n    width: 60px;\r\n    height: 60px;\r\n    box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;\r\n    border-radius: 50%;\r\n    background: rgb(36, 44, 52);\r\n    animation: 250ms ease 0s 1 normal none running animation-bhegco;\r\n    transition: opacity 0.3s ease 0s;\r\n}\r\n\r\n.webchat-draggable.help-desk-container .help-desk-style {\r\n    bottom: 0px;\r\n    width: 100px;\r\n    height: 60px;\r\n}\r\n\r\n.help-desk-launcher-frame.show {\r\n    opacity: 1!important;\r\n    visibility: visible!important;\r\n}\r\n\r\n.help-desk-launcher-frame.hide {\r\n  display: none;\r\n}\r\n\r\n.help-desk-container iframe {\r\n    border-width: 0px;\r\n    border-style: none;\r\n    border-color: transparent;\r\n    border-image: initial;\r\n    border-radius: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
